




import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class TrackMatching extends Vue {
  created() {
    this.$store.commit('trackmatching/init')
  }
}
